import { gql } from "graphql-tag";
import { basePageableGraphqlField, responseField } from "../../../base.graphql";

export const assignFields = `
            uniqueId
            warehouse
            warehouseUniqueId
            userList {
                id
                uniqueId
                firstName
                lastName
                email
                phone
                photo
                accountType
                isActive
                createdDate
                role {
                    id
                    uniqueId
                    roleName
                    roleIsSuperAdmin
                    roleDescription
                    roleCreateddate
                }
            }`;

export const ASSIGN_PERSON_TO_WAREHOUSE = gql`
    mutation AddWarehouseUserMutation($input:  WarehouseUserInput!) {
        addWarehouseUserMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${assignFields}
            }
        }
    }
`;

export const REMOVE_PERSON_TO_WAREHOUSE = gql`
    mutation RemoveWarehouseUserMutation($uniqueId: String!)  {
        removeWarehouseUserMutation(uniqueId: $uniqueId)  {
            response {
                ${responseField}
            }
        
        }
    }
`;


export const REMOVE_ASSIGNED_PERSON_FROM_WAREHOUSE = gql`
mutation RemoveAssignedPersonFromWarehouseMutation($uniqueId: String!) {
    removeWarehouseUserMutation(uniqueId: $uniqueId) {
        response {
            ${responseField}
        }
    }
}
`;

export const GET_ASSIGNED_PERSON_IN_WAREHOUSE = gql`
    query GetAllWarehouseUsers($filtering: WarehouseUserFilterinObject) {
        getAllWarehouseUsers(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
            ${assignFields}
        }
            page {
               ${basePageableGraphqlField}
            }
        }
    }
`;

export const TRANSFER_WAREHOUSE_ASIGNEES = gql `mutation TransferWarehouseUserMutation($input: TransferWarehouseUserInput!) {
    transferWarehouseUserMutation(input: $input) {
        response {
            ${responseField}
        }
        data{
            id
            uniqueId
            firstName
            lastName
            email
            phone
            photo
            accountType
            isActive
            createdDate
        }
    }
}`